<template lang="pug">
  bloco#sitemap.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Unidades
      p A PROAD é constituída pelas seguintes unidades:
    //- CONTENT
    .conteudo(slot="content")
      ul.listagem.lista
        li.item Assessoria Técnica – ASTEC
        li.item Coordenadoria Administrativa – CA
        li.item Coordenadoria de Transportes – CGT
        li.item Coordenadoria de Convênios – CC
        li.item Coordenadoria de Gestão de Espaços Físicos – CGEF
        li.item Coordenadoria de Gestão da Informação – CGI
        li.item Diretoria de Contabilidade e Finanças – DCF
        li.item Diretoria de Contratos – DC
        li.item Diretoria de Logística – DL
        li.item: router-link(:to="{ name: 'DCOMIndex' }") Diretoria de Compras – DCOM
        li.item Diretoria de Segurança Patrimonial – DSP
      p Clique no nome da unidade para visitar a sua seção.
</template>

<style lang="scss">
  #sitemap {
    .conteudo {
      .listagem {
        margin: 5px 0 5px 15px;
        > .item {
          margin: 5px 0;
          &:before {
            content: '\f0da';
            font-family: FontAwesome;
            color: $color-blue-dark;
            margin-right: 7px;
          }
        }
      }
      > .lista {
        margin: 30px 0;
      }
    }
  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import Titulo from 'COMPONENTS/ElementTitle'

export default {
  components: {
    Bloco,
    Titulo
  }
}
</script>



// WEBPACK FOOTER //
// Unidades.vue?60947dca